<template>
    <div
        class="p-6 bg-slate-300/30 rounded-2xl shadow-inner border-solid border-b border-t-0 border-x-0 border-white flex-col gap-4 flex"
    >
        <div>
            <div class="font-bold text-xs text-slate-700 mb-2">Status</div>
            <vx-box color="info" class="p-4">
                <div class="flex flex-col gap-3">
                    <div
                        v-for="statusOption in statusesOptions"
                        :key="statusOption.value"
                        class="flex gap-2 items-center text-sm cursor-pointer"
                        :data-test="`status-${statusOption.value}`"
                        @click.prevent="filters.status = statusOption.value"
                        @keydown.space.prevent="filters.status = statusOption.value"
                        @keydown.enter.prevent="filters.status = statusOption.value"
                    >
                        <vx-radio :modelValue="filters.status === statusOption.value"></vx-radio>
                        {{ statusOption.label }}
                    </div>
                </div>
            </vx-box>
        </div>
        <div>
            <div class="font-bold text-xs text-slate-700 mb-2">Parent Team</div>
            <vx-selectable
                v-model="filters.parent_id"
                placeholder="-"
                :reduce="(option) => option.value"
                :loading="loadingParentTeams"
                :options="parentTeams"
                @search="searchParentTeams"
                :clearable="false"
                data-test="parent-teams-selectable"
            >
            </vx-selectable>
        </div>
        <div>
            <div class="font-bold text-xs text-slate-700 mb-2">Favorite</div>
            <vx-box color="info" class="p-4">
                <div class="flex flex-col gap-3">
                    <div
                        v-for="favoriteOption in favoriteOptions"
                        :key="favoriteOption.value"
                        class="flex gap-2 items-center text-sm cursor-pointer"
                        @click.prevent="filters.is_favorite = favoriteOption.value"
                        @keydown.space.prevent="filters.is_favorite = favoriteOption.value"
                        @keydown.enter.prevent="filters.is_favorite = favoriteOption.value"
                    >
                        <vx-radio :modelValue="filters.is_favorite === favoriteOption.value"></vx-radio>
                        {{ favoriteOption.label }}
                    </div>
                </div>
            </vx-box>
        </div>
    </div>
</template>

<script setup>
import { VxBox, VxRadio, VxSelectable } from '@voxie/frontend-components';
import { ref } from 'vue';
import { useToasted } from '~/composables/useToasted';
import { adminTeamsClient } from '~/services';
import debounce from '~/utils/debounce';

const toasted = useToasted();

const statusesOptions = [
    { label: 'All', value: undefined },
    { label: 'Active', value: 'active' },
    { label: 'Draft', value: 'pending' },
    { label: 'Suspended', value: 'suspended' },
    { label: 'Closed', value: 'closed' },
];
const favoriteOptions = [
    { label: 'All', value: undefined },
    { label: 'Yes', value: '1' },
    { label: 'No', value: '0' },
];

const filters = defineModel({
    default: () => ({}),
});

const parentTeams = ref([]);
const loadingParentTeams = ref();

const searchParentTeams = debounce((query) => {
    loadingParentTeams.value = true;

    adminTeamsClient
        .getTeams({
            is_parent: 1,
            query: query,
        })
        .then((response) => {
            parentTeams.value = response.data.data.map((team) => ({
                value: team.id,
                label: `${team.id} - ${team.name}`.trim(),
            }));
        })
        .catch((e) => {
            console.error(e);
            toasted.global.platform_error();
        })
        .finally(() => {
            loadingParentTeams.value = false;
        });
}, 300);

searchParentTeams();
</script>
